/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const VectorDrawIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Vector Draw',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m33.134 11.26-8.416-8.414a1.068 1.068 0 0 0-1.51 0l-3.717 3.716a1.052 1.052 0 0 0-.147 1.289l8.42 8.42.008-.017.186.183a1.066 1.066 0 0 0 1.509 0l3.667-3.666a1.066 1.066 0 0 0 0-1.511ZM17.462 9.383l-7.877 3.628a2 2 0 0 0-1.011 1.051L1.979 29.973a1 1 0 0 0 .216 1.09l.523.523 8.156-8.157a1.619 1.619 0 0 1-.037-.254 2 2 0 1 1 2 2 1.684 1.684 0 0 1-.276-.04l-8.147 8.148.592.592a1 1 0 0 0 1.09.217l15.913-6.6a2 2 0 0 0 1.05-1.011l3.628-7.876Z"
    />
  </svg>`;
};
